import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

const state = { market: '' };

export default { state, mutations, actions, getters };
